module.exports = __webpack_public_path__ + "img/hot.aef972c0.svg";